// src/App.js
import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import "./App.css";

import Home from "./pages/Home";
import WhyUs from "./pages/WhyUs";
import WhatWeDo from "./pages/WhatWeDo";
import HowWeDo from "./pages/HowWeDo";
import AdTouchpoints from "./pages/AdTouchpoints";
import Help from "./pages/Help";

import BottomNav from "./components/BottomNav";

function App() {
  const location = useLocation();
  const hideBottomNav = location.pathname === "/"; // hide on Home page

  return (
    <div className="w-screen h-screen bg-black text-white flex flex-col justify-between overflow-hidden">
      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/why-us" element={<WhyUs />} />
          <Route path="/what-we-do" element={<WhatWeDo />} />
          <Route path="/how-we-do" element={<HowWeDo />} />
          <Route path="/ad-touchpoints" element={<AdTouchpoints />} />
          {/* <Route path="/orchestration" element={<AdTouchpoints />} /> */}
          <Route path="/Help" element={<Help />} />
        </Routes>
      </div>
      {<BottomNav />}
    </div>
  );
}

// ✅ Router wrapper (important)
export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
